import React, {Component} from 'react';
import axios from 'axios';
import OwlCarousel from 'react-owl-carousel';
import cookie from 'react-cookies';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Navigation from './Navigation';
import Header from './Header';
import Footer from './Footer';
import Modal from "react-bootstrap/Modal";
import 'bootstrap/dist/css/bootstrap.min.css';
import AddAsset from './AddAsset';
import Autocomplete from "./Autocomplete";
import AddCharacter from './AddCharacter';
import ReactPlayer from 'react-player'
import {Redirect} from 'react-router';

import '../App.css';

import Chinese from '../translations/cn';
import English from '../translations/en';
import Japanese from '../translations/jp';
import Korean from '../translations/ko';
import German from '../translations/ge';
import French from '../translations/fr';
import Spanish from '../translations/sp';
import Italian from '../translations/it';
import Russian from '../translations/ru';
import Portuguese from '../translations/po';
import Hindi from '../translations/hi';
import Arabic from '../translations/ar';

export const dictionaryList = {
	English,
	Chinese,
	Japanese,
	Korean,
	German,
	French,
	Spanish,
	Italian,
	Russian,
	Portuguese,
	Hindi,
	Arabic
};

class Character extends Component{
	constructor(props){
		super(props);

		this.state = {
			characterId: 0,
			characterImage: null,
			characterData: null,
			characterName: '',
			assetList: [],
			dataLanguage: dictionaryList['English'],
			activeClass: 'subCharacterItem',
			editTitle: false,
			showSelectAssetPopup: false,
			showAddAssetPopup: false,
			currentAssetList: null,
			currentAssetImageList: null,
			currentAssetListView: null,
			currentVideoList: [],
			currentVideoUrlList: [],
			gameAssetList: null,
			gameAssetLabelList: null,
			selectedAsset: null,
			videoView: null,
			assetValue: 0,
			showAddCharacterPopup: false,
			editable: false,
			playDays: 0,
			redirect: null,
			toCurrency: null,
			orgCurrencyList: [],
			assetValueString: null,
			gameCurrency: 0,
			targetUSD: '',
			assetPrice: 0,
			gameCurrencyValue: 0,
			currentGameCurrency: { name: '', rate: 100 },
			gameList: []
		}	
		
		this.getGameList = this.getGameList.bind(this);
		this.updateCharacterData = this.updateCharacterData.bind(this);
		this.setWrapperRef = this.setWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.makeAssetList = this.makeAssetList.bind(this);
		this.setActiveCharacter = this.setActiveCharacter.bind(this);
		this.getAssetValueString = this.getAssetValueString.bind(this);
	}
	
	componentWillMount(){
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);

		if ( localStorage.getItem('Language') ) {
			this.setState({
				dataLanguage: dictionaryList[localStorage.getItem('Language')]
			});
		} else {
			this.setState({
				dataLanguage: dictionaryList['English']
			});
		}

		this.getGameList();
		this.getCurrencyList();
	}

	getGameList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getGameList')
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						gameList: response.data
					})
				}
			})
	}

	getCurrencyList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getCurrencyList')
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						orgCurrencyList: response.data
					});

					this.getCharacterData();
				}
			})
	}

	getTargetCurrency() {
		var filteredOptions = [];

		if ( localStorage.getItem('countryId') ) {
			filteredOptions = this.state.orgCurrencyList.filter(
				(currency) =>
				currency.countryId == localStorage.getItem('countryId')
			);

			if (filteredOptions.length == 0) {
				filteredOptions = this.state.orgCurrencyList.filter(
					(currency) =>
					currency.status == 2
				);
			}
		}

		if (filteredOptions.length) {
			this.setState({
				toCurrency: filteredOptions[0]
			})
		} else {
			this.setState({
				toCurrency: null
			})
		}
	}

	getAssetValueString() {
		this.getTargetCurrency();

		var symbol = '$';
		var price = this.state.assetValue;
		if (this.state.toCurrency) {
			var symbol = this.state.toCurrency.symbol;
			var price = parseFloat((parseFloat(price) * parseFloat(this.state.toCurrency.rate)).toFixed(2));
		}

		this.setState({
			assetValueString: symbol + price,
			assetPrice: price
		})
		
		// return (
		// 		<span>{symbol + price}</span>
		// 	);
	}

	setWrapperRef(node) {
		this.wrapperRef = node;
	}

	handleClickOutside(event) {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.setState({
				showSelectAssetPopup: false
			})
		}
	}

	updateCharacterData(image) {
		localStorage.setItem('characterImage', image);
		this.setState({
			characterImage: image
		}, function(){
			this.refs.header.setAlertMessage(this.state.dataLanguage['character_updated']);
			this.getCharacterData();
		})

	}

	getCharacterData() {
		if (parseInt(localStorage.getItem('characterId')) > 0) {
			var characterId = localStorage.getItem('characterId');
			// localStorage.setItem('characterId', 0);

			this.setState({
				characterId: characterId
			})

			axios.defaults.withCredentials = true;

			axios.get(window.$backend_url + '/getCharacterDetails?characterId=' + characterId)
				.then(response => {
					if ( response.status == 200 && response.data.length ) {
						var diffDays = 0;
						if (response.data[0].creationDate) {
							const oneDay = 24 * 60 * 60 * 1000;
							var creationDate = new Date(response.data[0].creationDate);
							var currentDate = new Date();
							diffDays = Math.round((currentDate - creationDate) / oneDay);
							if ( diffDays < 0 ) {
								diffDays = 0;
							}
						}

						this.setState({
							characterData: response.data[0],
							characterName: response.data[0].name,
							playDays: diffDays
						})

						if (response.data[0].active) {
							this.setState({
								activeClass: 'subCharacterItem active'
							})
						}

						if (!this.state.characterImage) {
							if (response.data[0].mainImageUrl) {
							this.setState({
								characterImage: response.data[0].mainImageUrl
							})
							} else {
								this.getCharacterImage();
							}
						}

						if (response.data[0].userId == cookie.load('cookieId')) {
							this.setState({
								editable: true
							})
						}

						const filteredOptions = this.state.orgCurrencyList.filter(
							(currency) =>
							currency.gameId == response.data[0].gameId
						);

						if (filteredOptions.length) {
							this.setState({
								currentGameCurrency: filteredOptions[0],
								gameCurrency: filteredOptions[0].rate * response.data[0].price
							})
						}

						this.converteCurrency();
						this.getGameAssetList();
						this.getCharacterAssetData();
						this.getCharacterVideoList();
						this.getCharacterEnhancementList();
					}
				})
		}
	}

	getGameAssetList() {
		axios.defaults.withCredentials = true;

		axios.get(window.$backend_url + '/getTopAssetList?gameId=' + this.state.characterData.gameId)
			.then(response => {
				if ( response.status === 200 ) {
					var temp = [];
					for (var i=0; i<response.data.length; i++) {
						temp.push(response.data[i].name);
					}

					this.setState({
						gameAssetList: response.data,
						gameAssetLabelList: temp
					});
				}
			})
	}

	getCharacterVideoList() {
		axios.defaults.withCredentials = true;

		axios.get(window.$backend_url + '/getCharacterVideos?characterId=' + this.state.characterData.id)
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						currentVideoList: response.data,
						currentVideoUrlList: []
					})
					
					for (var i=0; i<response.data.length; i++) {
						let currentIndex = i;
						let temp = this.state.currentVideoUrlList;

						if (response.data[i].url) {
							temp.push(response.data[i].url);
							this.setState({
								currentVideoUrlList: temp
							})
						} else {
							temp.push('/assets/images/loading-2.gif');
							this.setState({
								currentVideoUrlList: temp
							})

							axios.get(window.$backend_url + '/getVideoFromS3?type=1&video=' + response.data[i].name)
								.then(response => {
									let tempList = this.state.currentVideoUrlList;
									tempList[currentIndex] = response.data;
									this.setState({
										currentVideoUrlList: tempList
									})

									this.makeVideoSlider();
								})
						}
					}

					this.makeVideoSlider();
				}
			})
	}

	makeVideoSlider() {
		let videos = this.state.currentVideoUrlList.map((video, index) => {
			if (video === '/assets/images/loading-2.gif') {
				return (<img key={index} src={video} />);
			} else {
				return (<ReactPlayer key={index} url={video} controls />);
			}
		})

		this.setState({
			videoView: null
		})

		if (this.state.currentVideoUrlList.length) {
			this.setState({
				videoView: videos
			})
		}
	}

	getCharacterAssetData() {
		const data = {
			characterId: this.state.characterData.id
		}

		axios.defaults.withCredentials = true;

		axios.post(window.$backend_url + '/getCharacterAssetData', data)
			.then(response => {
				if ( response.status === 200 ) {
					let tempList = [];
					let value = 0;
					for (var i = 0; i < response.data.length; i++) {
						if (response.data[i].mainImageUrl) {
							tempList.push(response.data[i].mainImageUrl);
						} else {
							tempList.push('/assets/images/loading.gif');
						}

						value += response.data[i].price;
					}

					this.setState({
						currentAssetList: response.data,
						currentAssetImageList: tempList,
						assetValue: value,
						assetValueString: null
					})

					this.getAssetValueString();

					for (i = 0; i < response.data.length; i++) {
						let currentIndex = i;
						
						if (response.data[i].mainImageUrl) {

						} else {
							const data = {
								userId: response.data[i].userId,
								gameId: response.data[i].gameId,
								assetId: response.data[i].id
							}

							axios.post(window.$backend_url + '/getAssetMainImage', data)
								.then(response => {
									if ( response.status === 200 ) {
										let temp = this.state.currentAssetImageList;
										temp[currentIndex] = response.data;
										this.setState({
											currentAssetImageList: temp
										})

										this.makeAssetList();
									}
								})
								.catch(error => {
									let temp = this.state.currentAssetImageList;
									temp[currentIndex] = 'assets/images/popular-game-main.jpg';
									this.setState({
										currentAssetImageList: temp
									})

									this.makeAssetList();
								})
						}
					}

					this.makeAssetList();
				}
			})
			.catch(error => {
				
			})
	}

	getCharacterImage() {
		if (localStorage.getItem('characterImage')) {
			this.setState({
				characterImage: localStorage.getItem('characterImage')
			})

			// localStorage.removeItem('characterImage');
		} else {
			const data = {
				userId: this.state.characterData.userId,
				gameId: this.state.characterData.gameId,
				characterId: this.state.characterData.id
			}

			axios.post(window.$backend_url + '/getCharacterMainImage', data)
				.then(response => {
					if ( response.status === 200 ) {
						this.setState({
							characterImage: response.data
						})
					}
				})
				.catch(error => {
					this.setState({
						characterImage: 'assets/images/popular-game-main.jpg'
					})
				})
		}
	}

	getCharacterEnhancementList() {
		axios.defaults.withCredentials = true;

		axios.get(window.$backend_url + '/getCharacterEnhancementList?characterId=' + this.state.characterData.id)
			.then(response => {
				if ( response.status === 200 ) {
					var temp = this.state.characterData;
					temp.characterEnhancementList = response.data;
					this.setState({
						characterData: temp
					});
				}
			})
	}

	searchAsset(val) {
		const filteredOptions = this.state.gameAssetList.filter(
			(asset) =>
			asset.name.toLowerCase().indexOf(val.toLowerCase()) > -1
		);

		if (filteredOptions.length) {
			this.setState({
				selectedAsset: filteredOptions[0]
			})
		} else {
			this.setState({
				selectedAsset: null
			})
		}
	}

	addAsset() {
		if (this.state.selectedAsset && this.state.characterData.userId == cookie.load('cookieId')) {
			this.setState({
				showSelectAssetPopup: false
			})

			const data = {
				characterId: this.state.characterData.id,
				assetId: this.state.selectedAsset.id
			}

			axios.post(window.$backend_url + '/addCharacterAsset', data)
				.then(response => {
					if ( response.status === 200 ) {
						var temp = this.state.currentAssetList;
						this.state.selectedAsset.characterAssetId = response.data;
						temp.push(this.state.selectedAsset);
						this.setState({
							currentAssetList: temp,
							assetValue: this.state.assetValue + this.state.selectedAsset.price
						})

						this.getAssetValueString();

						if (this.state.selectedAsset.mainImageUrl) {
							temp = this.state.currentAssetImageList;
							temp.push(this.state.selectedAsset.mainImageUrl);
							this.setState({
								currentAssetImageList: temp
							})

							this.makeAssetList();
						} else {
							var currentIndex = this.state.currentAssetImageList.length;

							temp = this.state.currentAssetImageList;
							temp.push('/assets/images/loading.gif');
							this.setState({
								currentAssetImageList: temp
							})

							this.makeAssetList();

							const data = {
								userId: this.state.characterData.userId,
								gameId: this.state.characterData.gameId,
								assetId: this.state.selectedAsset.id
							}							

							axios.post(window.$backend_url + '/getAssetMainImage', data)
								.then(response => {
									if ( response.status === 200 ) {
										let temp = this.state.currentAssetImageList;
										temp[currentIndex] = response.data;
										this.setState({
											currentAssetImageList: temp
										})

										this.makeAssetList();
									}
								})
								.catch(error => {
									let temp = this.state.currentAssetImageList;
									temp[currentIndex] = 'assets/images/popular-game-main.jpg';
									this.setState({
										currentAssetImageList: temp
									})

									this.makeAssetList();
								})
						}
					}
				})
		}
	}

	closeAsset = (e) => {
		var currentIndex = e.target.getAttribute('rel');
		const data = {
			id: this.state.currentAssetList[currentIndex].characterAssetId
		}

		axios.post(window.$backend_url + '/deleteCharacterAsset', data)
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						assetValue: this.state.assetValue - this.state.currentAssetList[currentIndex].price
					})

					this.getAssetValueString();

					var temp = this.state.currentAssetImageList.filter((x,i) => i !== parseInt(currentIndex));
					this.setState({
						currentAssetImageList: temp
					})

					temp = this.state.currentAssetList.filter((x,i) => i !== parseInt(currentIndex));
					this.setState({
						currentAssetList: temp
					}, function(){
						this.makeAssetList();
					})
				}
			})
			.catch(error => {
			})
	}

	makeAssetList() {
		let assets = this.state.currentAssetList.map((asset, index) => {
			let backStyle = {
				backgroundImage: "url('" + this.state.currentAssetImageList[index] + "')"
			}

			return(
					<div key={index} className="col-lg-3 col-md-6 col-sm-3 col-6 characterAsset">
						<div className="assetItem">
							<div className="assetImage" style={backStyle} onClick={this.goAssetDescription.bind(this)} rel={index}></div>
							{ this.state.editable ?
								<div className="btn_wrap">
									<button className="close_asset" onClick={this.closeAsset} rel={index}></button>
								</div>
							: null }
							<div className="assetname">{asset.name}</div>
						</div>
					</div>
				)
		})

		this.setState({
			currentAssetListView: null
		})

		this.setState({
			currentAssetListView: assets
		})
	}

	goAssetDescription(e) {
		localStorage.setItem('assetId', this.state.currentAssetList[e.target.getAttribute('rel')].id);
		localStorage.setItem('assetImage', this.state.currentAssetImageList[e.target.getAttribute('rel')]);
		localStorage.setItem('assetOwnerId', 0);
		localStorage.setItem('assetOwnerName', '');
		localStorage.setItem('assetOwnerAvatar', '');
		// this.setState({ redirect: "/assetDescription" });
		this.props.history.push('/assetDescription');
	}

	setLanguage(lang) {
		this.setState({
			dataLanguage: dictionaryList[lang]
		}, function(){
			
		})

	}

	checkLogin() {
		if (cookie.load('cookieId')) {
			this.setState({
				isLogin: true
			})
		} else {
			this.setState({
				isLogin: false,
				editable: false
			})
		}
		
		this.getAssetValueString();

		if (this.state.characterData) {
			if (this.state.characterData.userId == cookie.load('cookieId')) {
				this.setState({
					editable: true
				}, function(){
					this.makeAssetList();
				})
			} else {
				this.setState({
					editable: false
				}, function(){
					this.makeAssetList();
				})
			}
		}
	}

	selectCharacter(e) {
		if ( this.state.characterData.userId == cookie.load('cookieId') ) {
			if (this.state.activeClass === 'subCharacterItem active') {
				this.setState({
					activeClass: 'subCharacterItem'
				})

				this.setActiveCharacter();
			} else {
				axios.defaults.withCredentials = true;

				axios.get(window.$backend_url + '/getActiveCharacterCount?userId=' + cookie.load('cookieId'))
					.then(response => {
						if ( response.status === 200 ) {
							if ( (localStorage.getItem('userRole') == 1 && response.data[0].count < 1) ||  (localStorage.getItem('userRole') == 2 && response.data[0].count < 3) ) {
								this.setState({
									activeClass: 'subCharacterItem active'
								})

								this.setActiveCharacter();
							}
						}
					})
			}
		}
	}

	setActiveCharacter()  {
		const data = {
			userId: cookie.load('cookieId'),
			characterId : this.state.characterData.id
		}
		
		axios.post(window.$backend_url + '/activeCharacter',data)
			.then(response => {
				if(response.status === 200){
					this.getTopThreeCharacters();
				}
			})
			.catch(error => {
			})
	}

	toggleAddCharacterPopup() {
		this.setState({
			showAddCharacterPopup: !this.state.showAddCharacterPopup
		})
	}

	toggleSelectAsset() {
		this.setState({
			showSelectAssetPopup: !this.state.showSelectAssetPopup
		})
	}

	toggleAddAssetPopup() {
		if (cookie.load('cookieId')) {
			this.setState({  
				showAddAssetPopup: !this.state.showAddAssetPopup
			});
		} else {
			this.setState({  
				showAddAssetPopup: false
			});

			this.refs.header.toggleSignupPopup();
		}
	}

	changeCreatioinDateHandle(e) {
		const data = {
			characterId: this.state.characterData.id,
			creationDate: e.target.value.toString()
		}

		var temp = this.state.characterData;
		temp.creationDate = e.target.value.toString();
		this.setState({
			characterData: temp
		})

		if (this.state.editable) {
			axios.defaults.withCredentials = true;

			axios.post(window.$backend_url + '/setCharacterCreationDate', data)
				.then(response => {
				})
				.catch(error => {
				})
		}
	}

	changeGameCurrencyHandler(e) {
		if (this.state.editable) {
			const gameCurrency = (e.target.validity.valid) ? e.target.value : this.state.gameCurrency;
			this.setState({ gameCurrency });
		}
	}

	converteCurrency() {
		var targetString = "$0";
		var gameCurrencyValue = 0;
		if (this.state.gameCurrency && this.state.currentGameCurrency.name) {
			gameCurrencyValue = this.state.gameCurrency / this.state.currentGameCurrency.rate;
			targetString = '$' + this.state.gameCurrency / this.state.currentGameCurrency.rate;
		}

		this.setState({
			targetUSD: targetString,
			gameCurrencyValue: gameCurrencyValue
		})

		if (this.state.editable && this.state.gameCurrency && this.state.currentGameCurrency.name) {
			const data = {
				characterId: this.state.characterData.id,
				gameCurrencyValue: gameCurrencyValue
			}

			axios.defaults.withCredentials = true;
			axios.post(window.$backend_url + '/setCharacterGameCurrencyValue', data)
				.then(response => {
				})
				.catch(error => {
				})
		}
	}

	render(){
		if (this.state.redirect) {
			return <Redirect to={this.state.redirect} />
		}

		return(
			<div className="digit character">
				<Header history={this.props.history} ref="header" dataLanguage={this.state.dataLanguage} setLanguage={this.setLanguage.bind(this)} checkLogin={this.checkLogin.bind(this)} />
				<div>
					<section className="banner">
						<div className="container">
							<Navigation active="2" dataLanguage={this.state.dataLanguage} history={this.props.history} header={this.refs.header} />
							
							{ this.state.characterData ?									
								<div className="characterName">
									<p>{this.state.characterName}</p>
									{ this.state.editable ?
										<button className="btn_yellow_out" onClick={this.toggleAddCharacterPopup.bind(this)}>{this.state.dataLanguage['edit']}</button>
									: null }
								</div>
							: null }
							<div className="row">
								<div className="col-md-6">
									{ this.state.characterImage ?
										<div className="characterImage">
											<img src={this.state.characterImage} alt={this.state.characterName} />
											<div className={this.state.activeClass}>
												<label className="btnCehckCharacterOut">
													<span className="checkmark" onClick={this.selectCharacter.bind(this)} ></span>
												</label>
											</div>
										</div>
									: null }
								</div>
								<div className="col-md-6">
									<div className="row characterAssetWrap">
										{ this.state.currentAssetListView ?
											this.state.currentAssetListView
										: null }
										{ this.state.editable ?
											<div className="col-lg-3 col-md-6 col-sm-3 col-6 characterAsset">
												<div className="btn_select_asset_out">
													<button className="btn_select_asset" onClick={this.toggleSelectAsset.bind(this)} ></button>
													{ this.state.showSelectAssetPopup ?
														<div ref={this.setWrapperRef} className="select_asset_wrap">
															<div className="custom_autocomplete">
																<Autocomplete
																	options = {this.state.gameAssetLabelList}
																	changeValue = {this.searchAsset.bind(this)}
																/>
															</div>
															<div className="flex">
																<button className="btn_yellow" onClick={this.addAsset.bind(this)} >{this.state.dataLanguage['add_asset']}</button>
																<button className="btn_yellow" onClick={this.toggleAddAssetPopup.bind(this)}>{this.state.dataLanguage['create_asset']}</button>
															</div>
														</div>
													: null }
												</div>
											</div>
										: null }
									</div>
								</div>
							</div>

							{ this.state.characterData ?
								<div className="row character_info">
									<div className="col-md-6">
										<div className="border_yellow">
											<div className="text_part">
												<div className="row fixed_info">
													<div className="col-md-6 text-center">
														<p><span className="text-yellow">Level:</span> { this.state.characterData.level }</p>
														<p><span className="text-yellow">Class:</span> { this.state.characterData.class_name }</p>
													</div>
													<div className="col-md-6 text-center">
														<p><span className="text-yellow">Race:</span> { this.state.characterData.race_name }</p>
														<p><span className="text-yellow">Gender:</span> { this.state.characterData.gender_name }</p>
													</div>
												</div>
											</div>
											<div className="text_part back_yellow text-center">
												<p>{this.state.dataLanguage['agg_character_networth']}</p>
											</div>
											<div className="text_part text-center">
												<p className="text-green">${this.state.assetPrice + this.state.gameCurrencyValue}</p>
											</div>
											<div className="text_part back_yellow text-center">
												<p>{this.state.dataLanguage['agg_time_played']}</p>
											</div>
											{ this.state.editable && this.state.characterData ?
												<div className="text_part text-center">
													<p className="text-yellow">{this.state.dataLanguage['enter_character_creation_date']}</p>
													<input type="date" onChange={this.changeCreatioinDateHandle.bind(this)} value={this.state.characterData.creationDate} />
												</div>
											: 
												<div className="text_part text-center">
													<p className="text-green text-play-days">{this.state.playDays} {this.state.dataLanguage['days']}</p>
												</div>	
											}
										</div>
									</div>
									<div className="col-md-6">
										<div className="border_yellow">
											<div className="text_part back_yellow text-center">
												<p>{this.state.dataLanguage['total_assets']}:</p>
											</div>
											<div className="text_part text-center">
												{ this.state.currentAssetList ?
													<p className="text-green">{ this.state.currentAssetList.length }</p>
												: <p className="text-green">0</p> }
											</div>
											<div className="text_part back_yellow text-center">
												<p>{this.state.dataLanguage['agg_asset_value']}</p>
											</div>
											<div className="text_part text-center">
												<p className="text-green">{this.state.assetValueString}</p>
											</div>
											<div className="currency_info">
												<div className="row">
													<div className="col-md-6 text-center">
														<p className="text-yellow">{this.state.dataLanguage['in_game_currency']}</p>
														<input type="text" pattern="[0-9.]*" value={this.state.gameCurrency} onChange={this.changeGameCurrencyHandler.bind(this)} />
														{ this.state.currentGameCurrency.name ?
															<p className="gameCurrencyName text-yellow">({this.state.currentGameCurrency.name})</p>
														: null }
													</div>
													<div className="col-md-6 text-center">
														<p className="text-yellow">{this.state.dataLanguage['real_world_value']}</p>
														<p className="text-green mt-15">{this.state.targetUSD}</p>
													</div>
												</div>
												{ this.state.editable ?
													<img className="converter rotating" alt="converter" src="/assets/images/converter-fill.png" onClick={this.converteCurrency.bind(this)} />
												: null }
											</div>
										</div>
									</div>
								</div>
							: null }

							{ this.state.videoView ?
								<div className="banner-slider video-slider">
									<div className="owl-slider">
										<OwlCarousel id="videoSlider" items={1} className="owl-theme" loop nav margin={1} responsiveClass={true} >
											{ this.state.videoView }
										</OwlCarousel>
									</div>
								</div>
							: null }
						</div>
					</section>
				</div>
				<Footer dataLanguage={this.state.dataLanguage} header={this.refs.header} />
				{this.state.showAddAssetPopup ?  
					<Modal show={this.state.showAddAssetPopup} onHide={this.toggleAddAssetPopup.bind(this)} animation={false} className="largeModal">
						<Modal.Header closeButton>
						</Modal.Header>
						<AddAsset dataLanguage={this.state.dataLanguage} closeAddAssetPopup={this.toggleAddAssetPopup.bind(this)} gameList={this.state.gameList} />
					</Modal>
				: null  
				}
				{this.state.showAddCharacterPopup ?  
					<Modal show={this.state.showAddCharacterPopup} onHide={this.toggleAddCharacterPopup.bind(this)} animation={false} className="largeModal">
						<Modal.Header closeButton>
						</Modal.Header>
						<AddCharacter dataLanguage={this.state.dataLanguage} closeAddCharacterPopup={this.toggleAddCharacterPopup.bind(this)} characterData={this.state.characterData} characterImage={this.state.characterImage} videoList={this.state.currentVideoList} videoUrlList={this.state.currentVideoUrlList} updateData={this.updateCharacterData.bind(this)} gameList={this.state.gameList} />
					</Modal>
				: null  
				}
			</div>
		)
	}
}

export default Character;


// WEBPACK FOOTER //
// ./src/components/Character.js